import { Component, OnInit } from '@angular/core';
import {EventsService} from "../../../events.service";
import {GlobalService} from "../../../../global.service";

@Component({
  selector: 'app-qualified-player',
  templateUrl: './qualified-player.component.html',
  styleUrls: ['./qualified-player.component.scss']
})
export class QualifiedPlayerComponent implements OnInit {
  loadIndicator = false
  participants;

  constructor(private eventService: EventsService, public globalService: GlobalService) {
  }

  ngOnInit() {
    this.loadIndicator = true

    this.eventService.getParticipants('zfg7538G1OIl', 1).subscribe((res) => {
      this.participants = res.participants;
      this.loadIndicator = false

    });
  }

}
